import { gql } from 'apollo-boost';

export const GET_SCHOOL_BOOMBASSADORS = gql`
    query getSchoolBoombassadors($schoolId: ID!) {
        getSchoolBoombassadors(schoolId: $schoolId) {
            id
            boomerAvatarUrl
            updatedAt
            firstName
            lastName
            classes {
                id
                name
            }
        }
    }
`;

export const GET_STUDENTS_FROM_CLASS = gql`
    query studentsClass($id: ID!) {
        studentsClass(id: $id) {
            id
            students {
                id
                boomerAvatarUrl
                updatedAt
                displayName
                classes {
                    id
                    name
                }
            }
        }
    }
`;

export const UPDATE_BOOMBASSADOR_SCHOOL_STATUS = gql`
    mutation updateBoombassadorSchoolStatus($studentIds: [ID!]!, $isBoombassador: Boolean!, $schoolId: ID!) {
        updateBoombassadorSchoolStatus(studentIds: $studentIds, isBoombassador: $isBoombassador, schoolId: $schoolId) {
            errors
        }
    }
`;

export const FIND_STUDENTS_BY_NAME = gql`
query studentsByName($name: String!, $schoolId: ID!) {
    studentsByName(name: $name, schoolId: $schoolId) {
        id
        displayName
        avatarUrl
        classes {
            id
            name
        }
    }
}
`;
